import { type Offer } from 'typescript/types/api/offers';

export const offerFixture = (overrides = null): Offer => {
  const defaults = {
    token: 'defaultToken',
    number_payment_periods: 3,
    financed_amount: {
      amount: '100.00',
      currency_code: 'USD',
    },
    fee_amount: {
      amount: '10.00',
      currency_code: 'USD',
    },
    payment_amount: {
      amount: '20.00',
      currency_code: 'USD',
    },
    final_payment_amount: {
      amount: '30.00',
      currency_code: 'USD',
    },
    total_owed_amount: {
      amount: '110.00',
      currency_code: 'USD',
    },
    selected: true,
  };

  return { ...defaults, ...overrides };
};
